import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 20px;

  .ant-skeleton-paragraph {
    margin: 0;
  }

  .ant-skeleton-paragraph > li {
    height: 12px;
    margin-top: 0 !important;
  }
`;
